import {
    Box,
    Chip,
    Collapse,
    Grid,
    Icon,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Paper,
    Tooltip,
    Typography
} from "@mui/material";
import {Fragment, useState} from "react";
import {Link} from "react-router-dom";
import {useDetalheOcorrencia} from "../../api/DpgeIntegracaoEsfingeApi";
import {formataDataLegal} from "../../shared/dataUtil";
import {getResumo, getTitulo} from "../../shared/ocorrenciaUtil";
import {getReferenciaTemporalOcorrencia} from "../../shared/ocorrenciaTemporalUtil";
import {useQuery} from "../../shared/useQueryParam";
import ArquivarButton from "../arquivar/ArquivarButton";
import IconEstado from "../estado/IconEstado";
import {getSituacaoOcorrencia} from "../../shared/situacaoOcorrencia";

function PainelOcorrencias({ocorrencias}) {
    const [hoverId, setHoverId] = useState();
    const [expandedIds, setExpandedIds] = useState({});
    const query = useQuery();
    const ocorrenciasHierarquicas = montarHierarquiaOcorrencias(ocorrencias);

    if (!ocorrencias) return null;

    function toggleExpand(event, ocorrenciaId) {
        event.preventDefault();
        event.stopPropagation();
        setExpandedIds((ids) => ({
            ...ids,
            [ocorrenciaId]: !ids[ocorrenciaId]
        }));
    }

    return (
        <List component={Paper} sx={{padding: 0}}>
            {ocorrenciasHierarquicas.map((ocorrencia) => (
                <Fragment key={ocorrencia.id}>
                    <OcorrenciaItem
                        ocorrencia={ocorrencia}
                        hoverId={hoverId}
                        setHoverId={setHoverId}
                        query={query}
                        expanded={Boolean(expandedIds[ocorrencia.id])}
                        onToggleExpand={toggleExpand}
                    />
                    <Collapse
                        in={Boolean(expandedIds[ocorrencia.id])}
                        timeout="auto"
                        unmountOnExit
                    >
                        <List component="div" disablePadding>
                            {ocorrencia.ocorrenciasFilhas.map((filha) => (
                                <OcorrenciaItem
                                    key={filha.id}
                                    ocorrencia={filha}
                                    hoverId={hoverId}
                                    setHoverId={setHoverId}
                                    query={query}
                                    child
                                    ocorrenciaRaiz={ocorrencia}
                                />
                            ))}
                        </List>
                    </Collapse>
                </Fragment>
            ))}
        </List>
    );
}

function OcorrenciaItem({
    ocorrencia,
    hoverId,
    setHoverId,
    query,
    child = false,
    ocorrenciaRaiz,
    expanded = false,
    onToggleExpand
}) {
    const possuiFilhas = ocorrencia.ocorrenciasFilhas?.length > 0;
    const deveBuscarDetalhe =
        deveExibirChavePacote(ocorrencia, child) &&
        !ocorrencia.codigoRegistroInformacao;
    const {data: ocorrenciaDetalhada} = useDetalheOcorrencia(ocorrencia.id, {
        enabled: deveBuscarDetalhe
    });
    const ocorrenciaResumo = ocorrenciaDetalhada || ocorrencia;
    const cancelamentoConcluido = ocorrencia.cancelamentoConcluido;
    const situacao = getSituacaoOcorrencia(ocorrencia);
    const resumo = getResumoListaOcorrencia(
        ocorrenciaResumo,
        child,
        ocorrenciaRaiz
    );
    let corFundo = child ? "action.hover" : "background.paper";
    if (cancelamentoConcluido) {
        corFundo = "status.error";
    }

    return (
        <ListItem
            onMouseLeave={() => setHoverId(null)}
            onMouseOver={() => setHoverId(ocorrencia.id)}
            sx={(theme) => ({
                borderBottom: `1px solid ${theme.palette.divider}`,
                borderLeft: cancelamentoConcluido
                    ? `4px solid ${theme.palette.error.main}`
                    : undefined,
                paddingLeft: child ? theme.spacing(7) : undefined,
                bgcolor: corFundo,
                ".MuiListItemSecondaryAction-root ": {
                    top: theme.spacing(3)
                }
            })}
            button
            component={Link}
            to={`/eventos/${ocorrencia.id}?${query.toString()}`}
            secondaryAction={
                hoverId === ocorrencia.id || ocorrencia.arquivado ? (
                    <ArquivarButton ocorrencia={ocorrencia} />
                ) : (
                    <ListItemText
                        secondary={formataDataLegal(ocorrencia.dataHora)}
                        sx={{whiteSpace: "nowrap"}}
                    />
                )
            }
        >
            <ListItemIcon>
                {possuiFilhas ? (
                    <Tooltip
                        title={
                            expanded
                                ? "Ocultar etapas vinculadas"
                                : "Exibir etapas vinculadas"
                        }
                    >
                        <IconButton
                            size="small"
                            color="primary"
                            aria-label={
                                expanded
                                    ? "Ocultar etapas vinculadas"
                                    : "Exibir etapas vinculadas"
                            }
                            onClick={(event) =>
                                onToggleExpand(event, ocorrencia.id)
                            }
                        >
                            <Icon>
                                {expanded ? "expand_more" : "chevron_right"}
                            </Icon>
                        </IconButton>
                    </Tooltip>
                ) : (
                    <Box
                        sx={{
                            width: 34,
                            display: "flex",
                            justifyContent: "center"
                        }}
                    >
                        <IconEstado
                            estado={ocorrencia.estadoEnvio}
                            ocorrencia={ocorrencia}
                        />
                    </Box>
                )}
            </ListItemIcon>
            <Grid container justifyContent="space-between" wrap="nowrap">
                <Grid item minWidth={0}>
                    <ListItemText
                        primary={
                            <Box display="flex" alignItems="center" gap={1}>
                                {possuiFilhas && (
                                    <IconEstado
                                        estado={ocorrencia.estadoEnvio}
                                        ocorrencia={ocorrencia}
                                    />
                                )}
                                <Typography
                                    component="span"
                                    fontWeight={child ? 400 : 500}
                                    noWrap
                                >
                                    {getTitulo(ocorrencia)}
                                </Typography>
                                {!child && (
                                    <Chip
                                        size="small"
                                        variant="outlined"
                                        label={
                                            ocorrencia.destinoEntrega ===
                                            "FORNECEDOR"
                                                ? "Fornecedor"
                                                : ocorrencia.destinoEntrega ===
                                                  "ESFINGE_DIRETO"
                                                ? "e-Sfinge direto"
                                                : "Sem destino definido"
                                        }
                                    />
                                )}
                                {cancelamentoConcluido && (
                                    <Chip
                                        size="small"
                                        color="error"
                                        variant="outlined"
                                        icon={<Icon>cancel</Icon>}
                                        label="Cancelada"
                                    />
                                )}
                            </Box>
                        }
                        secondary={
                            <>
                                {resumo}
                                <Typography
                                    component="span"
                                    variant="caption"
                                    display="block"
                                    sx={{
                                        mt: 0.5,
                                        fontWeight: 600,
                                        color: "text.primary"
                                    }}
                                    title={situacao.descricao}
                                >
                                    {situacao.label}
                                </Typography>
                                {ocorrencia.destinoEntrega === "FORNECEDOR" &&
                                    situacao.descricao && (
                                        <Typography
                                            component="span"
                                            variant="caption"
                                            display="block"
                                            color="text.secondary"
                                        >
                                            {situacao.descricao}
                                        </Typography>
                                    )}
                            </>
                        }
                    />
                    {possuiFilhas && (
                        <Typography variant="caption" color="text.secondary">
                            {ocorrencia.ocorrenciasFilhas.length} etapa
                            {ocorrencia.ocorrenciasFilhas.length === 1
                                ? ""
                                : "s"}{" "}
                            vinculada
                            {ocorrencia.ocorrenciasFilhas.length === 1
                                ? ""
                                : "s"}
                        </Typography>
                    )}
                </Grid>
            </Grid>
        </ListItem>
    );
}

export function getResumoListaOcorrencia(
    ocorrencia,
    child = false,
    ocorrenciaRaiz
) {
    const eventoAtual = ocorrencia?.eventoAtual || "";
    const referenciaTemporal = getReferenciaTemporalOcorrencia(
        ocorrencia,
        ocorrenciaRaiz
    ).itens.map((item) => [item.rotulo, item.valor]);
    const resumoCancelamento = getResumoCancelamentoConcluido(ocorrencia);

    if (
        eventoAtual === "CANCELAR_TRANSMISSAO_POR_CODIGO_REGISTRO" ||
        eventoAtual === "CANCELAR_TRANSMISSAO_ENVIO_PARCIAL"
    ) {
        const codigoRegistro =
            ocorrencia.codigoCancelamento ||
            ocorrencia?.dadosEnviados?.codigoRegistro;
        const chavePacote =
            ocorrencia.chaveCancelamento ||
            ocorrencia?.dadosEnviados?.chavePacote;
        const origem = ocorrencia.ocorrenciaOrigemCancelamentoId
            ? `#${ocorrencia.ocorrenciaOrigemCancelamentoId} ${
                  ocorrencia.eventoOrigemCancelamento || ""
              }`.trim()
            : "Não vinculada";

        return montarResumo([
            ["Id", ocorrencia.id],
            ["Origem", origem],
            [
                codigoRegistro ? "Código" : "Pacote",
                resumirIdentificador(codigoRegistro || chavePacote)
            ],
            ...referenciaTemporal
        ]);
    }

    if (deveExibirChavePacote(ocorrencia, child)) {
        return montarResumo([
            ["Id", ocorrencia.id],
            ["N\u00famero de registro", getCodigoRegistro(ocorrencia)],
            ...referenciaTemporal,
            ...resumoCancelamento
        ]);
    }

    if (child && eventoAtual.includes("PARCIAL")) {
        return montarResumo([
            ["Id", ocorrencia.id],
            ["Lote", getNumeroLote(ocorrencia)],
            ["Quantidade de registros", getQuantidadeRegistros(ocorrencia)],
            ...referenciaTemporal,
            ...resumoCancelamento
        ]);
    }

    return (
        <>
            {getResumo(ocorrencia)}
            {montarResumo(referenciaTemporal)}
            {montarResumo(resumoCancelamento)}
            {ocorrencia.ocorrenciaDependenciaId &&
                montarResumo([
                    ["Etapa anterior", `#${ocorrencia.ocorrenciaDependenciaId}`]
                ])}
        </>
    );
}

function getResumoCancelamentoConcluido(ocorrencia) {
    const cancelamento = ocorrencia?.cancelamentoConcluido;
    if (!cancelamento) {
        return [];
    }

    const rotuloIdentificador =
        cancelamento.tipoIdentificador === "CHAVE_PACOTE"
            ? "Pacote cancelado"
            : "Código cancelado";

    return [
        ["Cancelada pela ocorrência", `#${cancelamento.ocorrenciaId}`],
        [rotuloIdentificador, resumirIdentificador(cancelamento.identificador)]
    ];
}

export function deveExibirChavePacote(ocorrencia, child = false) {
    return Boolean(child && ocorrencia?.eventoAtual?.includes("FINALIZAR"));
}

function montarResumo(dados) {
    return (
        <>
            {dados.map(([label, valor]) => (
                <ResumoItem key={label} label={label} valor={valor} />
            ))}
        </>
    );
}

function ResumoItem({label, valor}) {
    return (
        <Box component="span" sx={{whiteSpace: "nowrap", mr: 2}}>
            <Box component="span" sx={{fontWeight: 500}}>
                {label}:
            </Box>
            <Box component="span" sx={{ml: 0.5}}>
                {valor ?? ""}
            </Box>
        </Box>
    );
}

function getCodigoRegistro(ocorrencia) {
    return getPrimeiroValor(ocorrencia, [
        "codigoRegistroInformacao",
        "codigoRegistro",
        "numeroRegistro",
        "registro"
    ]);
}

function resumirIdentificador(valor) {
    if (!valor || valor.length <= 20) {
        return valor;
    }
    return `${valor.slice(0, 10)}…${valor.slice(-8)}`;
}

function getNumeroLote(ocorrencia) {
    return getPrimeiroValor(ocorrencia, ["numeroLote", "lote"]);
}

function getQuantidadeRegistros(ocorrencia) {
    return (
        getPrimeiroValor(ocorrencia, [
            "qtdeRegistros",
            "quantidadeRegistros",
            "quantidadeRegistrosLote",
            "totalRegistrosLote",
            "totalRegistros",
            "registrosProcessados",
            "quantidade"
        ]) ??
        getTamanhoArrayDadosEnviados(ocorrencia) ??
        getTamanhoPrimeiraLista(ocorrencia, ["registros", "servidores"])
    );
}

function getPrimeiroValor(origem, chaves) {
    const visitados = new Set();

    function procurar(valor) {
        const valorNormalizado = normalizarValorBusca(valor);

        if (
            !valorNormalizado ||
            typeof valorNormalizado !== "object" ||
            visitados.has(valorNormalizado)
        ) {
            return undefined;
        }

        visitados.add(valorNormalizado);
        valor = valorNormalizado;

        const chaveEncontrada = chaves.find(
            (chave) => valor[chave] !== undefined && valor[chave] !== null
        );

        if (chaveEncontrada) {
            return valor[chaveEncontrada];
        }

        const filhosPrioritarios = [
            valor.dadosEnviados,
            valor.payload,
            valor.dados,
            valor.resposta
        ];

        for (const filho of filhosPrioritarios) {
            const encontrado = procurar(filho);
            if (encontrado !== undefined) {
                return encontrado;
            }
        }

        for (const filho of Object.values(valor)) {
            const encontrado = Array.isArray(filho)
                ? procurarLista(filho)
                : procurar(filho);
            if (encontrado !== undefined) {
                return encontrado;
            }
        }

        return undefined;
    }

    function procurarLista(lista) {
        for (const item of lista) {
            const encontrado = procurar(item);
            if (encontrado !== undefined) {
                return encontrado;
            }
        }
        return undefined;
    }

    return procurar(origem);
}

function getTamanhoArrayDadosEnviados(ocorrencia) {
    const dadosEnviados = normalizarValorBusca(ocorrencia?.dadosEnviados);

    return Array.isArray(dadosEnviados) ? dadosEnviados.length : undefined;
}

function getTamanhoPrimeiraLista(origem, chaves) {
    const visitados = new Set();

    function procurar(valor) {
        const valorNormalizado = normalizarValorBusca(valor);

        if (Array.isArray(valorNormalizado)) {
            return procurarLista(valorNormalizado);
        }

        if (
            !valorNormalizado ||
            typeof valorNormalizado !== "object" ||
            visitados.has(valorNormalizado)
        ) {
            return undefined;
        }

        visitados.add(valorNormalizado);
        valor = valorNormalizado;

        const chaveEncontrada = chaves.find((chave) =>
            Array.isArray(normalizarValorBusca(valor[chave]))
        );

        if (chaveEncontrada) {
            return normalizarValorBusca(valor[chaveEncontrada]).length;
        }

        for (const filho of Object.values(valor)) {
            const encontrado = procurar(filho);
            if (encontrado !== undefined) {
                return encontrado;
            }
        }

        return undefined;
    }

    function procurarLista(lista) {
        for (const item of lista) {
            const encontrado = procurar(item);
            if (encontrado !== undefined) {
                return encontrado;
            }
        }
        return undefined;
    }

    return procurar(origem);
}

function normalizarValorBusca(valor) {
    if (typeof valor !== "string") {
        return valor;
    }

    const texto = valor.trim();

    if (!texto || !["{", "["].includes(texto[0])) {
        return valor;
    }

    try {
        return JSON.parse(texto);
    } catch (error) {
        return valor;
    }
}

export function montarHierarquiaOcorrencias(ocorrencias = []) {
    const porId = new Map();

    ocorrencias.forEach((ocorrencia) => {
        porId.set(ocorrencia.id, {
            ...ocorrencia,
            ocorrenciasFilhas: [...(ocorrencia.ocorrenciasFilhas || [])]
        });
    });

    porId.forEach((ocorrencia) => {
        ocorrencia.ocorrenciasFilhas.forEach((filha) => {
            if (!porId.has(filha.id)) {
                porId.set(filha.id, {
                    ...filha,
                    ocorrenciasFilhas: filha.ocorrenciasFilhas || []
                });
            }
        });
    });

    porId.forEach((ocorrencia) => {
        if (
            !ocorrencia.ocorrenciaPaiId ||
            !porId.has(ocorrencia.ocorrenciaPaiId)
        ) {
            return;
        }

        const pai = porId.get(ocorrencia.ocorrenciaPaiId);
        const filhaJaVinculada = pai.ocorrenciasFilhas.some(
            (filha) => filha.id === ocorrencia.id
        );

        if (!filhaJaVinculada) {
            pai.ocorrenciasFilhas.push(ocorrencia);
        }
    });

    porId.forEach((ocorrencia) => {
        ocorrencia.ocorrenciasFilhas = ordenarOcorrenciasPorFluxoServidores(
            ocorrencia.ocorrenciasFilhas
        );
    });

    return ocorrencias
        .filter(
            (ocorrencia) =>
                !ocorrencia.ocorrenciaPaiId ||
                !porId.has(ocorrencia.ocorrenciaPaiId)
        )
        .map((ocorrencia) => porId.get(ocorrencia.id));
}

export function ordenarOcorrenciasPorFluxoServidores(ocorrencias = []) {
    return [...ocorrencias].sort((a, b) => {
        const prioridadeA = getPrioridadeFluxoServidores(a);
        const prioridadeB = getPrioridadeFluxoServidores(b);

        if (prioridadeA !== prioridadeB) {
            return prioridadeA - prioridadeB;
        }

        return 0;
    });
}

function getPrioridadeFluxoServidores(ocorrencia) {
    const eventoAtual = ocorrencia?.eventoAtual || "";

    if (eventoAtual.includes("SERVIDORES_INICIAR")) {
        return 1;
    }

    if (eventoAtual.includes("SERVIDORES_ENVIAR_PARCIAL")) {
        return 2;
    }

    if (
        eventoAtual.includes("SERVIDORES_FINALIZAR") ||
        eventoAtual.includes("FINALIZAR_TRANSMISSAO_SERVIDORES")
    ) {
        return 3;
    }

    return 100;
}

export default PainelOcorrencias;
